import * as React from 'react';
import {
    Column,
    CommonDataTableProps,
    DataTableData,
    SortDirection
} from './DataTable';
import { ControlBar, ControlBarProps } from './Controls/ControlBar';
import { FillPopup } from './Fill/FillPopup';
import { Filter } from './Filter/Filter';
import { Table } from './Table/Table';

export interface FullDataTableProps<T extends DataTableData>
    extends CommonDataTableProps<T> {
    /**
     * Properties for the Control Bar
     */
    controlBarProps: ControlBarProps;
    /**
     * True to display show active only checkbox
     */
    activeFiltering: boolean;
    /**
     * Optional column to filter on
     */
    filterColumn?: Column;
    /**
     * Filter input change handler
     */
    onFilterChange: (filterText: string) => void;
    /**
     * Show active only change handler
     */
    onActiveChange: (checked: boolean) => void;
    /**
     * Text of the filter input
     */
    filterText: string;
    /**
     * State of the show active only checkbox
     */
    showActiveOnly: boolean;
}

export function FullDataTable<T extends DataTableData>(
    props: FullDataTableProps<T>
) {
    return (
        <div id={'orchardDataTable_' + props.idSuffix}>
            <Filter
                idSuffix={props.idSuffix}
                key={'filter_' + props.idSuffix}
                showActiveFilter={props.activeFiltering}
                showColumnFilter={props.filterColumn ? true : false}
                filterColumnName={
                    props.filterColumn ? props.filterColumn.title : ''
                }
                onFilterChange={(filterText: string) =>
                    props.onFilterChange(filterText)
                }
                onActiveChange={(checked: boolean) =>
                    props.onActiveChange(checked)
                }
                filterText={props.filterText}
                showActiveOnly={props.showActiveOnly}
            />
            <div
                className="simple-data-table-parent copia_color1_b"
                style={props.style}
            >
                <ControlBar {...props.controlBarProps} />
                <div
                    className="simple-data-table-fixed-div"
                    style={{
                        minHeight:
                            props.controlBarProps.itemsPerPage.itemsPerPage * 28 + 26
                    }}
                >
                    <Table
                        columns={props.columns}
                        sortColumn={props.sortColumn}
                        onSort={(
                            sortColumn: Column,
                            sortDirection: SortDirection
                        ) => props.handleSort(sortColumn, sortDirection)}
                        sortDirection={props.sortDirection}
                        items={props.displayedData}
                        onInputChange={(
                            itemKey: string,
                            column: Column,
                            value: string
                        ) =>
                            props.handleInputColumnChange(
                                itemKey,
                                column,
                                value
                            )
                        }
                        showFillPopup={(column, event) =>
                            props.showFillPopup(column, event)
                        }
                    />
                </div>
                <ControlBar {...props.controlBarProps} />
            </div>
            <FillPopup
                onClose={(fillAll: boolean, value?: string) =>
                    props.fillProps.onClose(fillAll, value)
                }
                show={props.fillProps.show}
                x={props.fillProps.x}
                y={props.fillProps.y}
            />
        </div>
    );
}
